import { useReducer } from 'react';

export enum LoginAction {
  CONTINUAR,
  ERROR,
  ERROR_TOKEN,
  REINICIAR,
}
/**
 * Posibles estados:
 * EMAIL: se espera que el usuario ingrese email.
 * ESPERANDO_RESPUESTA_EMAIL: se espera respuesta de backend luego de haber enviado email.
 * TOKEN: se espera que el usuario ingrese el token otp.
 * ESPERANDO_RESPUESTA_TOKEN: espera respuesta de backend luego de haber enviado token.
 * ERROR_EMAIL_STATUS: hubo un error en la etapa de email.
 * ERROR_TOKEN_STATUS: hubo un error en la etapa de token.
 * ERROR_STATUS: error general no recuperable.
 */
export enum LoginStatus {
  EMAIL,
  ESPERANDO_RESPUESTA_EMAIL,
  TOKEN,
  ESPERANDO_RESPUESTA_TOKEN,
  ERROR_EMAIL_STATUS,
  ERROR_TOKEN_STATUS,
  ERROR_STATUS,
}

const ERROR_STATUS = [LoginStatus.ERROR_EMAIL_STATUS, LoginStatus.ERROR_TOKEN_STATUS, LoginStatus.ERROR_STATUS];
const LOADING_STATUS = [LoginStatus.ESPERANDO_RESPUESTA_EMAIL, LoginStatus.ESPERANDO_RESPUESTA_TOKEN];
const CONFIRM_ENABLED_STATUS = [LoginStatus.EMAIL, LoginStatus.ERROR_EMAIL_STATUS];

export const loginStatusReducer = (state: LoginStatus, action: LoginAction) => {
  switch (action) {
    case LoginAction.CONTINUAR: {
      if (state < LoginStatus.ESPERANDO_RESPUESTA_TOKEN) return state + 1;

      if (state === LoginStatus.ERROR_EMAIL_STATUS) return LoginStatus.ESPERANDO_RESPUESTA_EMAIL;

      if (state === LoginStatus.ERROR_TOKEN_STATUS) return LoginStatus.ESPERANDO_RESPUESTA_TOKEN;

      return LoginStatus.ERROR_STATUS;
    }
    case LoginAction.REINICIAR: {
      return LoginStatus.EMAIL;
    }
    case LoginAction.ERROR: {
      if (state === LoginStatus.ESPERANDO_RESPUESTA_EMAIL) return LoginStatus.ERROR_EMAIL_STATUS;
      return LoginStatus.ERROR_STATUS;
    }
    case LoginAction.ERROR_TOKEN: {
      return LoginStatus.ERROR_TOKEN_STATUS;
    }
  }
};

export const useLoginStatus = () => {
  const [status, dispatch] = useReducer(loginStatusReducer, LoginStatus.EMAIL);

  const isLoading = LOADING_STATUS.includes(status);
  const isError = ERROR_STATUS.includes(status);

  const showTokenInput = status === LoginStatus.TOKEN || status === LoginStatus.ERROR_TOKEN_STATUS;
  const showEmail = status === LoginStatus.EMAIL || status === LoginStatus.ERROR_EMAIL_STATUS || showTokenInput;
  const showConfirmButton = CONFIRM_ENABLED_STATUS.includes(status);
  const showCancelButton = status === LoginStatus.EMAIL || status === LoginStatus.ERROR_EMAIL_STATUS;
  const emailBlocked = status !== LoginStatus.EMAIL && status !== LoginStatus.ERROR_EMAIL_STATUS;

  return [status, dispatch, isLoading, isError, showEmail, showTokenInput, showConfirmButton, showCancelButton, emailBlocked] as const;
};
